module.exports = __webpack_public_path__ + "a6bd0c3f0d80ee6bba42a61cf41fb0a1.pdf";